// ECI old's add/edit flat form (its chunk tableModalFlatEdit, the desktop part) as the admin's flat card: its rows with
// its labels, by the apartments column each fills, and its checks on save (scripts_eci_main_new.js). The value lists
// of its selects come from the server (meta.lists, backend service/oldFlatForm.js).
// The owner, 27.10.2026: «каждое поле должно быть как на старом».

const f = (key, label, extra = {}) => ({key, label, ...extra})

// the form's own fields that are not columns: where the flat is, and «Координаты» as one «lat, lon» input
export const PLACE = {complex: '__complex', queue: '__queue', building: '__building', section: '__section'}
export const COORDS = '__coords'

// after Застройщик | Название ЖК | Очередь and Корпус | Секция | Кол-во комнат
export const MAIN_ROWS = [
  [f('totalSquare', 'Площадь без балконов/лоджий'), f('kitchenSquare', 'Кухня'), f('balconyArea', 'Балкон')],
  [f('loggiaArea', 'Лоджия'), f('actualPrice', 'Цена на руки'), f('priceInAgreement', 'Цена в договоре')],
  [f('ads', 'Реклама'), f('deposit', 'Залог'), f('rewardTitle', 'Вознаграждение')],
  [f('ceilings', 'Высота потолков'), f('floor', 'Этаж'), f('totalFloors', 'Этажность')],
  [f('encumbranceBank', 'Обременение'), f('paymentLeft', 'Остаток'), f('willPay', 'Гасит ли')],
  [f('fullOfMoneyInTheAgreement', 'Готов показать полную стоимость'), f('taxRefund', 'Компенсация налога'), f('documents', 'Документы')],
  [f('salesman', 'Продавец'), f('worksWithAnAgent', 'Работает с агентом'), f('saleTarget', 'Цель продажи')],
  [f('assistant', 'Ассистент'), f('oneHundredPercentOverpaymentConcession', 'Уступка при 100% предоплате'), f('numberOnFloor', 'Номер на этаже')],
  [f('sellStarted', 'Как давно продают'), f('gradeName', 'Оценка'), f('complexNameText', 'Имя ЖК для вторички')],
]

// one per line
export const CONTACT_FIELDS = [
  f('ownerFullName', 'Контакты ФИО'),
  f('contact', 'Контакты Телефон'),
  f('agency', 'Агентство'),
  f('cianUrl', 'Ссылка'),
  f('crmDocumentsUrl', 'Ссылка на папку в CRM'),
]

// «Загрузить фотографии»: ECI old's slots, then «Больше фото +» (otherPhotos)
export const PHOTO_SLOTS = [
  f('layoutPhoto', 'Планировка'),
  f('floorPlanPhoto', 'План этажа'),
  f('masterPLan', 'Генплан'),
  f('photoFinishing', 'Фото отделки'),
  f('render', 'Рендер'),
  f('sixthPhoto', '6-е фото'),
]
export const PHOTO_ORDER = f('photoOrder', 'Порядок фотографий в фиде')

export const REPORT_FIELDS = [f('dealId', 'ID номер сделки в битрикс')]

// ECI old shows these for «Вторичный рынок» only, and on a new flat until its developer is chosen; choosing «Вторичный
// рынок» sets the deadline to «Собственность» (scripts_eci_main_new.js, select.builder change)
export const SECONDARY_BUILDER = 'Вторичный рынок'
export const SECONDARY_DEADLINE = 'Собственность'
export const LOCATION_ROWS = [
  [f('districtName', 'Район'), f('subDistrict', 'Подрайон', {locked: true}), f('metroStations', 'Метро')],
  [f('deadline', 'Срок сдачи'), f('decorName', 'Отделка'), f('metroDistance', 'Расстояние до метро')],
  [f('agreement', 'Договор'), f('typeName', 'Тип')],
]

// a house, townhouse, cottage or plot (ECI old shows these for such rooms only); choosing one turns off the developer,
// ЖК, queue and building, so they are neither sent nor required
export const COUNTRY_ROOMS = ['Дом', 'Таунхаус', 'Коттедж', 'Участок']
// a new flat's slots that show its ЖК's picture until another file is chosen («Загрузить другое» / «Взять из ЖК»)
export const COMPLEX_PHOTO_SLOTS = ['masterPLan', 'render']
export const COUNTRY_ROWS = [
  [f('houseModel', 'Модель дома'), f('houseArea', 'Площадь Участка'), f('landArea', 'Площадь Дома')],
  [f('powerKw', 'Мощность КВт'), f('landStatus', 'Статус Земли'), f('houseBuiltYear', 'Срок сдачи')],
  [f('constructionPhase', 'Этап строительства'), f('location', 'Локация'), f('communication', 'Коммуникации')],
]

export const NOTE_FIELDS = [
  f('privateNotes', 'Внутреннее примечание', {area: true}),
  f('complexDescription', 'Описание ЖК/дома (Если не заполнено то подгружается из ЖК)', {area: true}),
]

export const DOCUMENT_ROWS = [
  [f('cadastralNumber', 'Кадастровый номер'), f('rosreestrNumber', 'Номер регистрации ДДУ в Росреестре'), f('shareholderName', 'ФИО дольщика')],
]
export const DOCUMENT_LINKS = [f('yandexDiskUrl', 'Ссылка яндекс диск'), f('egrnUrl', 'Ссылка для ЕГРН документов')]

// «Поля для работы с фидом»
export const FEED_ROWS = [
  [f('parking', 'Парковка'), f('bathroomType', 'Санузел'), f('windowsDirection', 'Вид из окон')],
  [f('passengerLifts', 'Пассажирских лифтов'), f('freightLifts', 'Грузовых лифтов'), f('videoUrl', 'Ссылка на видео')],
]
// the old form's only text areas are these and the notes; every other field is one line, whatever its column
export const FEED_TEXTS = [f('adDescription', 'Описание для фида', {area: true}), f('yandexAdDescription', 'Описание для фида яндекс', {area: true})]

// «Поля для работы с аналитикой»
export const ANALYSIS_ROWS = [
  [f('analysisPriceDdu', 'Цена в ДДУ'), f('analysisPriceAssignment', 'Цена в Цессии'), f('analysisPriceWaiting', 'Ожидаемая цена продавцом на руки')],
  [f('analysisPriceContract', 'Ожидаемая цена в договоре при данной цене'), f('analysisEncumbrance', 'Наличие обременений'), f('analysisTotal', 'Сумма для расчета прогноза')],
]

// columns the card shows in its own way (placement, coordinates, map, features, schedule, photos, the status at the top)
export const SPECIAL_FIELDS = ['builder', 'numberOfRooms', 'address', 'latitude', 'longitude', 'coordsArrows', 'featureIds',
  'installmentSchedule', 'houseNumber', 'statuses', 'postImage', ...PHOTO_SLOTS.map((p) => p.key), 'otherPhotos']

// ECI old's columns of the ads on the classifieds (its search list; its form has only «Ссылка»)
export const AD_LINKS = {
  cianUrl: 'Ссылка циан',
  cianSellerUrl: 'Ссылка циан продавец',
  avitoUrl: 'Ссылка авито ООО',
  avitoUrl2: 'Ссылка авито физик',
  avitoSellerUrl: 'Ссылка авито продавец',
  yandexUrl: 'Ссылка яндекс',
  domclickUrl: 'Ссылка дом клик',
}

// every column the old form has: the rest goes to «Прочие поля», for admins only
export const OLD_FORM_FIELDS = new Set([
  ...MAIN_ROWS.flat(), ...CONTACT_FIELDS, PHOTO_ORDER, ...REPORT_FIELDS, ...LOCATION_ROWS.flat(), ...COUNTRY_ROWS.flat(),
  ...NOTE_FIELDS, ...DOCUMENT_ROWS.flat(), ...DOCUMENT_LINKS, ...FEED_ROWS.flat(), ...FEED_TEXTS, ...ANALYSIS_ROWS.flat(),
].map((field) => field.key).concat(SPECIAL_FIELDS))

// ECI old's checks on save. Required when a flat is added (its list, «Банк» is the encumbrance select):
export const REQUIRED_ON_CREATE = [
  ['rewardTitle', 'Вознаграждение'], [PLACE.complex, 'ЖК'], ['builder', 'Застройщик'], [PLACE.queue, 'Очередь'],
  [PLACE.building, 'Корпус'], [PLACE.section, 'Секция'], ['coordsArrows', 'Вид из окна'], ['numberOfRooms', 'Комнатность'],
  ['totalSquare', 'Площадь'], ['floor', 'Этаж'], ['totalFloors', 'Этажность'], ['ads', 'Реклама'],
  ['crmDocumentsUrl', 'Ссылка на папку в CRM'], ['actualPrice', 'Цена на руки'], ['priceInAgreement', 'Цена в договоре'],
  ['encumbranceBank', 'Банк'], ['paymentLeft', 'Остаток'], ['willPay', 'Гасит ли'],
]
// «Цена на руки» of at least 6 digits: for a parking space, and for the market flats («2 - квартиры с рынка»)
const SHORT_PRICE_ROOMS = ['Паркинг']
const SHORT_PRICE_ADS = ['2 - квартиры с рынка']

const isEmpty = (value) => value === null || value === undefined || String(value).trim() === '' || (Array.isArray(value) && !value.length)
const isZero = (value) => isEmpty(value) || String(value).trim() === '0'

// values: the form's values; can: (key) => the user may change it. → [{ name, message }] as ECI old words them
export const oldChecks = (values, {isNew, can, scheduleTotal}) => {
  const errors = []
  const add = (name, message) => errors.push({name, message})
  if (isNew) {
    REQUIRED_ON_CREATE.forEach(([name, label]) => {
      if (can(name) && isEmpty(values[name])) add(name, `Заполните поле: ${label}`)
    })
  }
  if (can('crmDocumentsUrl') && isZero(values.crmDocumentsUrl) && !errors.some((e) => e.name === 'crmDocumentsUrl')) {
    add('crmDocumentsUrl', 'Заполните поле: Ссылка на папку в CRM')
  }
  if (can('numberOnFloor') && isZero(values.numberOnFloor)) add('numberOnFloor', 'Заполните поле: Номер на этаже')
  if (values.encumbranceBank === 'Рассрочка' && can('paymentLeft')) {
    if (isEmpty(values.paymentLeft)) add('paymentLeft', 'При рассрочке это поле обязательно к заполнению: Остаток')
    else if (Number(values.paymentLeft) === 0) add('paymentLeft', 'Поле не может иметь нулевое значение: Остаток')
    else if (Number(values.paymentLeft) !== scheduleTotal) add('paymentLeft', 'Поле должно содержать сумму платежей в графике: Остаток')
  }
  const shortPrice = SHORT_PRICE_ROOMS.includes(values.numberOfRooms) || SHORT_PRICE_ADS.includes(values.ads)
  if (shortPrice && can('actualPrice') && String(values.actualPrice ?? '').replace(/\D/g, '').length < 6) {
    add('actualPrice', 'Цена на руки не может быть короче 6 знаков')
  }
  return errors
}

// the old form's name of each column it has (the flats table's column titles)
export const OLD_LABELS = Object.fromEntries([
  ...MAIN_ROWS.flat(), ...CONTACT_FIELDS, ...PHOTO_SLOTS, PHOTO_ORDER, ...REPORT_FIELDS, ...LOCATION_ROWS.flat(), ...COUNTRY_ROWS.flat(),
  ...NOTE_FIELDS, ...DOCUMENT_ROWS.flat(), ...DOCUMENT_LINKS, ...FEED_ROWS.flat(), ...FEED_TEXTS, ...ANALYSIS_ROWS.flat(),
  f('builder', 'Застройщик'), f('numberOfRooms', 'Кол-во комнат'), f('address', 'Адрес'), f('installmentSchedule', 'График рассрочки'),
  f('houseNumber', 'Номер квартиры'), f('statuses', 'Статус на портале'), f('postImage', 'Оффер'), f('coordsArrows', 'Вид из окон (стрелка)'),
  f('featureIds', 'Особенности'), f('otherPhotos', 'Больше фото'),
].map((field) => [field.key, field.label]))
